import React from 'react';
import './RaceNotFound.css';

interface RaceNotFoundProps {
  show: boolean;
}

const RaceNotFound: React.FC<RaceNotFoundProps> = ({ show }) => {
  if (!show) return null;

  const handleSelectRace = () => {
    // Clear the race ID from URL and reload to show race selector
    const url = new URL(window.location.href);
    url.searchParams.delete('race');
    window.history.pushState({}, '', url.toString());
    window.location.reload();
  };

  return (
    <div className="race-not-found-overlay">
      <div className="race-not-found-content">
        <div className="race-not-found-icon">🏁</div>
        <h2>Race Not Found</h2>
        <p>This race doesn't exist or has been removed.</p>

        <button
          className="race-not-found-button"
          onClick={handleSelectRace}
        >
          Select a Different Race
        </button>

        <p className="race-not-found-subtext">
          Click the button above to choose from available races
        </p>
      </div>
    </div>
  );
};

export default RaceNotFound;